import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, NoFiltersHitCountAccessor, SuggestionsAccessor, renderComponent } from "../../../../core";
import { NoHitsErrorDisplay } from "./NoHitsErrorDisplay";
import { NoHitsDisplay } from "./NoHitsDisplay";

var defaults = require("lodash/defaults");

export var NoHits =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(NoHits, _SearchkitComponent);

  function NoHits() {
    var _this;

    _classCallCheck(this, NoHits);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NoHits).apply(this, arguments));
    _this.translations = NoHits.translations;
    return _this;
  }

  _createClass(NoHits, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(NoHits.prototype), "componentDidMount", this).call(this);

      this.noFiltersAccessor = this.searchkit.addAccessor(new NoFiltersHitCountAccessor());

      if (this.props.suggestionsField) {
        this.suggestionsAccessor = this.searchkit.addAccessor(new SuggestionsAccessor(this.props.suggestionsField));
      }
    }
  }, {
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var block = this.props.mod || "sk-no-hits";
      return {
        container: block
      };
    }
  }, {
    key: "getSuggestion",
    value: function getSuggestion() {
      return this.suggestionsAccessor && this.suggestionsAccessor.getSuggestion();
    }
  }, {
    key: "setQueryString",
    value: function setQueryString(query) {
      this.searchkit.getQueryAccessor().setQueryString(query, true);
      this.searchkit.performSearch(true);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.searchkit.getQueryAccessor().keepOnlyQueryState();
      this.searchkit.performSearch(true);
    }
  }, {
    key: "resetSearch",
    value: function resetSearch() {
      this.searchkit.getQueryAccessor().resetState();
      this.searchkit.performSearch(true);
    }
  }, {
    key: "getFilterCount",
    value: function getFilterCount() {
      return this.noFiltersAccessor && this.noFiltersAccessor.getCount();
    }
  }, {
    key: "render",
    value: function render() {
      if ((this.hasHits() || this.isInitialLoading() || this.isLoading()) && !this.getError()) return null;

      if (this.getError()) {
        var _props = {
          errorLabel: this.translate("NoHits.Error"),
          resetSearchFn: this.resetSearch.bind(this),
          translate: this.translate,
          bemBlocks: this.bemBlocks,
          tryAgainLabel: this.translate("NoHits.ResetSearch"),
          error: this.getError()
        };
        return renderComponent(this.props.errorComponent, _props);
      }

      var suggestion = this.getSuggestion();
      var query = this.getQuery().getQueryString();
      var infoKey = suggestion ? "NoHits.NoResultsFoundDidYouMean" : "NoHits.NoResultsFound";
      var props = {
        noResultsLabel: this.translate(infoKey, {
          query: query,
          suggestion: suggestion
        }),
        translate: this.translate,
        bemBlocks: this.bemBlocks,
        suggestion: suggestion,
        query: query,
        filtersCount: this.getFilterCount(),
        resetFiltersFn: this.resetFilters.bind(this),
        setSuggestionFn: this.setQueryString.bind(this, suggestion)
      };
      return renderComponent(this.props.component, props);
    }
  }]);

  return NoHits;
}(SearchkitComponent);
NoHits.translations = {
  "NoHits.NoResultsFound": "No results found for {query}.",
  "NoHits.NoResultsFoundDidYouMean": "No results found for {query}. Did you mean {suggestion}?",
  "NoHits.DidYouMean": "Search for {suggestion} instead",
  "NoHits.SearchWithoutFilters": "Search for {query} without filters",
  "NoHits.Error": "We're sorry, an issue occurred when fetching your results. Please try again.",
  "NoHits.ResetSearch": "Reset Search"
};
NoHits.propTypes = defaults({
  suggestionsField: PropTypes.string,
  translations: SearchkitComponent.translationsPropType(NoHits.translations)
}, SearchkitComponent.propTypes);
NoHits.defaultProps = {
  errorComponent: NoHitsErrorDisplay,
  component: NoHitsDisplay
};